
import Vue from "vue";
import dogService from "@/services/dogService";
import { UserInfo } from "@/types/User";
export default Vue.extend({
  name: "ShowResults",
  props: {
    dogId: String,
  },
  data: function () {
    return {
      showResultsHeaders: [
        { text: "Show Date", align: "left", value: "showDate", width: "100px" },
        { text: "Show ID", align: "left", value: "showId", width: "100px" },
        { text: "Descr.", align: "left", value: "description", width: "100px" },
        { text: "Category", align: "left", value: "category", width: "50px" },
        { text: "Division", align: "left", value: "division", width: "50px" },
        { text: "Score", align: "left", value: "score", width: "50px" },
        { text: "Transferred to ACE", align: "left", value: "transferredToAce" },
        { text: "Place", align: "left", value: "place" },
        { text: "Hit", align: "left", value: "hit" },
        { text: "Pt Sched.", align: "left", value: "ptSched" },
        { text: "# Competing", align: "left", value: "nCompeting" },
        { text: "SCCH Score", align: "left", value: "scchScore" },
        { text: "SCCH Major", align: "left", value: "isScchMajor" },
        { text: "Judge", align: "left", value: "judge" },
        { text: "Handler", align: "left", value: "handler" },
      ],
      filteredResults: [],
      search: "",
    };
  },
  methods: {    
    csvExport: function () {
        var filename = `ShowResults_${this.dogId?.trim()}_${new Date().toLocaleDateString()}.csv`;
        var content = this.filteredResults;
        const keys = Object.keys(content[0]);
        const commaSeparatedString = [keys.join(","), content.map((row: any) => keys.map(key => row[key]).join(",")).join("\n")].join("\n")
        const csvBlob = new Blob([commaSeparatedString])
        var link = document.createElement("a");
        var url = URL.createObjectURL(csvBlob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    },
  },
  created: function () {
    dogService
      .getDogShowResultsById(this.dogId, this.userInfo.personId)
      .then((res) => {
        this.filteredResults = res.data;
      })
      .catch((e) => console.log(e));
  },
  watch: {
    dogId: function (newVal: string) {
      dogService
        .getDogShowResultsById(newVal, this.userInfo.personId)
        .then((res) => {
          this.filteredResults = res.data;
        })
        .catch((e) => console.log(e));
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
